//#region src/assets/vana-square-waiting-logo.png
var vana_square_waiting_logo_default = "" + new URL("vana-square-waiting-logo-B3K4EehZ.png", import.meta.url).href;
//#endregion
export { vana_square_waiting_logo_default as default };

//# sourceMappingURL=vana-square-waiting-logo.js.map